import React from 'react';
import { RouteConfigComponentProps, renderRoutes } from 'react-router-config';
import { Box } from '@cp/ds/src/components/box';
import { authenticationTokenSelector } from '@cp/shared/api/core';
import { Stack } from '@cp/ds/src/components/stack';
import { useSelector } from 'react-redux';
import { ContentSkeleton } from '@cp/ds/src/components/contentSkeleton';
import { ScrollContainerContext } from 'src/shared/ui/scrollContainer';
import { useSupportDialogNotifications } from 'src/features/dialog/realtime';
import { useVacancyModerationNotifications } from 'src/features/vacancy';
import { useProcessingNotifications } from 'src/features/processing';
import { PageSidebar } from './components/sidebar';
import { PageHeader } from './components/header';
import { HEADER_HEIGHT } from './const';

const Login = React.lazy(() => import('src/features/auth').then((module) => ({ default: module.LoginForm })));

const AuthenticatedLayout: React.FC<RouteConfigComponentProps> = ({ route }) => {
  useSupportDialogNotifications();
  useVacancyModerationNotifications();
  useProcessingNotifications();

  const scrollContainerRef = React.useRef<HTMLDivElement>(null);
  const scrollContainerContextValue = React.useMemo(
    () => ({
      ref: scrollContainerRef,
    }),
    [],
  );

  return (
    <ScrollContainerContext.Provider value={scrollContainerContextValue}>
      <Box>
        <PageHeader />
        <Stack direction="row" sx={{ flexWrap: 'nowrap', position: 'relative', backgroundColor: 'background.paper' }}>
          <PageSidebar />
          <Box
            ref={scrollContainerRef}
            sx={{ position: 'relative', flex: '1 1 0px', pt: 2.5, pb: 5, height: `calc(100vh - ${HEADER_HEIGHT}px)`, overflowX: 'auto' }}
          >
            {renderRoutes(route?.routes)}
          </Box>
        </Stack>
      </Box>
    </ScrollContainerContext.Provider>
  );
};

export const Layout: React.FC<RouteConfigComponentProps> = (props) => {
  const isAdminAuthenticated = Boolean(useSelector(authenticationTokenSelector));

  if (!isAdminAuthenticated) {
    return (
      <React.Suspense fallback={<ContentSkeleton />}>
        <Login />
      </React.Suspense>
    );
  }

  return <AuthenticatedLayout {...props} />;
};
